<template>
  <v-card class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-4">
    <h3 class="c-blue-text c-title tw-text-base md:tw-text-xl tw-px-0 md:tw-px-10">
      <slot></slot>
      <hr class="tw-mt-4">
    </h3>
    <div class="tw-w-full tw-flex">
      <div class="tw-w-full tw-flex tw-justify-center tw-my-5 md:tw-my-8 tw-flex-wrap">
        <template v-if="scanObject(coverType,'productCode', '') === 702">
          <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2">
            <div class="my-2 tw-px-0 md:tw-px-6">
              <div class="tw-flex tw-px-2 md:tw-px-10 tw-items-center">
                <img src="/images/icons/car-g.png" class="tw-h-16 lg:tw-h-auto tw-mr-2 lg:tw-mr-4" alt="car icon">
                <h3 class="c-gray-text c-title tw-text-base md:tw-text-xl tw-px-2 md:tw-px-8"><span v-html="pageTitle"></span></h3>
              </div>
              <div
                  class="pa-2 tw-rounded mt-4 primary--text tw-flex tw-bg-gray-300 tw-self-auto tw-break-normal"
              >
                <v-icon class="primary--text float-left c-blue-text tw-font-bold tw-w-1/12 md:tw-w-1/12"
                >mdi-alert</v-icon
                >
                <p class="mb-0 ml-4">
                  Failure to pay a monthly instalment will initiate a cancellation of your policy within 14 days
                </p>
              </div>
            </div>
            <div
                class="my-2 tw-px-0 md:tw-px-6 tw-mt-5 md:tw-mt-0 tw-text-center lg:tw-text-left">
              <h4 class="c-blue-text tw-font-bold tw-text-sm">1st Instalment</h4>
              <h3 class="c-light-blue-text title-font tw-text-4xl md:tw-text-5xl">
                Kshs. {{ installments[0].premium | formatNum }}
              </h3>
              <h4 class="c-blue-text tw-font-bold tw-text-sm">
                Ksh. {{ installments[1].premium | formatNum }} per month for the following 11 months
              </h4>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="tw-flex tw-px-2 md:tw-px-10 tw-items-center">
            <img src="/images/icons/car-g.png" class="tw-h-16 lg:tw-h-auto tw-mr-2 lg:tw-mr-4" alt="car icon">
            <h3 class="c-gray-text c-title tw-text-base md:tw-text-xl tw-px-2 md:tw-px-8"><span v-html="pageTitle"></span></h3>
          </div>
          <div class="tw-px-0 md:tw-px-10 tw-mt-5 md:tw-mt-0 tw-text-center lg:tw-text-left">
            <h4 class="c-blue-text tw-font-bold tw-text-sm">Total Annual Premium</h4>
            <h3 class="c-light-blue-text title-font tw-text-4xl md:tw-text-5xl">
              Kshs. {{ premiumAmount  | formatNum }}
            </h3>
            <v-btn v-if="current === 'PaymentSelection'" color="secondary" class="tw-mt-2" large block :loading="loading" @click="$emit('proceed')">Confirm and Pay</v-btn>
          </div>
        </template>
      </div>
    </div>
    <div v-if="!progressHidden" class="tw-w-full tw-px-0 md:tw-px-8">
      <v-stepper alt-labels>
        <v-stepper-header>
          <v-stepper-step
              step="1"
              :complete="progress > 0"
          >
            Personal Details
          </v-stepper-step>
          <v-divider :color="progress > 0 ? 'secondary' : ''"></v-divider>
          <v-stepper-step
              step="2"
              :complete="progress > 35"
          >
            Vehicle Details
          </v-stepper-step>
          <v-divider :color="progress > 35 ? 'secondary' : ''"></v-divider>
          <v-stepper-step
              step="3"
              :complete="progress > 67"
          >
            Cover Summary
          </v-stepper-step>
          <v-divider :color="progress > 67 ? 'secondary' : ''"></v-divider>
          <v-stepper-step
              :complete="progress === 100"
              step="4">
            Make Payment
          </v-stepper-step>
        </v-stepper-header>
      </v-stepper>
    </div>
  </v-card>
</template>
<script>

import helpers from '@/utils/helpers';

export default {
  name: 'TopCard',
  props: {
    current: {
      type: String,
      default: '',
    },
    coverType: Object,
    instalments: Array,
    premiumAmount: Number,
    progressHidden: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    progress() {
      if (this.current === 'PersonalDetails') {
        return 0;
      }
      if (this.current === 'VehicleDetails') {
        return 33.33;
      }
      if (this.current === 'CoverSummary') {
        return 66.66;
      }
      if (this.current === 'BranchSelections') {
        return 80;
      }
      return 100;
    },
    pageTitle() {
      if (this.scanObject(this.coverType, 'covertypeId', '') === 120) {
        return `${this.coverType.productCode === 702 ? 'Bima Bamba' : 'Comprehensive'}<br> Insurance Cover`;
      }
      return 'Third Party <br> Only';
    },
    installments() {
      return this.instalments;
    },
  },
  filters: {
    formatNum(num) {
      return helpers.numberToString(num);
    },
  },
};
</script>
<style lang="scss">
$stepper-header-elevation: 0;
.v-stepper {
  box-shadow: none!important;
}
</style>
